// WebGL beauty & filter engine — works on ALL browsers incl. iOS Safari
// (canvas 2D ctx.filter is NOT supported on iOS; this replaces it).
// Face AR via MediaPipe FaceLandmarker; Body Restyle via MediaPipe PoseLandmarker.

export const BEAUTY_DEFAULTS = {
  smooth: 0, brighten: 0, whiten: 0, rosy: 0, glow: 0,
  vFace: 0, bigEyes: 0, chin: 0, slimNose: 0, teethWhiten: 0,
  bodySlim: 0, longLegs: 0,
};

export const BEAUTY_SLIDERS = [
  { key: "smooth", label: "Smooth Skin", emoji: "🧴" },
  { key: "brighten", label: "Brighten", emoji: "✨" },
  { key: "whiten", label: "Skin Whiten", emoji: "🤍" },
  { key: "rosy", label: "Rosy Glow", emoji: "🌸" },
  { key: "glow", label: "Soft Glow", emoji: "🌟" },
];

export const RESHAPE_SLIDERS = [
  { key: "vFace", label: "V-Face", emoji: "💎" },
  { key: "bigEyes", label: "Big Eyes", emoji: "👁️" },
  { key: "chin", label: "Chin Tip", emoji: "🔻" },
  { key: "slimNose", label: "Slim Nose", emoji: "👃" },
  { key: "teethWhiten", label: "Teeth White", emoji: "🦷" },
];

export const BODY_SLIDERS = [
  { key: "bodySlim", label: "Body Slim", emoji: "🧍" },
  { key: "longLegs", label: "Long Legs", emoji: "🦵" },
];

export const AR_STICKERS = [
  { key: "none", name: "None", icon: null },
  { key: "crown", name: "Crown", icon: "/assets/crown-maharaja.png" },
  { key: "dog", name: "Doggy", icon: "/assets/ar-dog-nose.png" },
  { key: "cat", name: "Kitty", icon: "/assets/ar-cat-ears.png" },
  { key: "sunglasses", name: "Shades", icon: "/assets/ar-sunglasses.png" },
  { key: "hearts", name: "Hearts", icon: "/assets/ar-heart.png" },
];

export const MAKEUP_LOOKS = [
  { key: "none", name: "None", swatch: "linear-gradient(135deg,#8b8b96,#3c3c46)" },
  { key: "rose", name: "Rose", swatch: "linear-gradient(135deg,#e795ac,#c45c7d)", lip: [206, 92, 125], lipA: 0.45, blush: [232, 132, 143], blushA: 0.24, liner: 0.45 },
  { key: "nude", name: "Nude Glam", swatch: "linear-gradient(135deg,#d9a08f,#b0715f)", lip: [190, 118, 100], lipA: 0.4, blush: [222, 160, 140], blushA: 0.16, liner: 0.6 },
  { key: "coral", name: "Coral", swatch: "linear-gradient(135deg,#f69078,#e05a42)", lip: [226, 96, 72], lipA: 0.48, blush: [240, 148, 118], blushA: 0.22, liner: 0.4 },
  { key: "redvelvet", name: "Red Velvet", swatch: "linear-gradient(135deg,#d94a5f,#8f1226)", lip: [168, 22, 48], lipA: 0.58, blush: [226, 120, 130], blushA: 0.2, liner: 0.7 },
  { key: "berry", name: "Berry", swatch: "linear-gradient(135deg,#b05a86,#6e2450)", lip: [128, 38, 78], lipA: 0.52, blush: [214, 122, 150], blushA: 0.2, liner: 0.6 },
  { key: "smokey", name: "Smokey", swatch: "linear-gradient(135deg,#9a8494,#3a2b3c)", lip: [156, 88, 98], lipA: 0.42, blush: [206, 140, 140], blushA: 0.14, liner: 0.95, smoke: 0.6 },
  { key: "maharani", name: "Maharani", swatch: "linear-gradient(135deg,#e8556b,#9c0f2e)", lip: [178, 26, 56], lipA: 0.6, blush: [235, 122, 132], blushA: 0.26, liner: 0.85, bindi: true },
];

export const BEAUTY_QUICK_PRESETS = [
  { key: "off", name: "Off", params: { smooth: 0, brighten: 0, whiten: 0, rosy: 0, glow: 0 } },
  { key: "natural", name: "Natural", params: { smooth: 30, brighten: 20, whiten: 15, rosy: 10, glow: 10 } },
  { key: "glam", name: "Glam", params: { smooth: 55, brighten: 35, whiten: 35, rosy: 25, glow: 25 } },
  { key: "royal", name: "Royal", params: { smooth: 65, brighten: 30, whiten: 40, rosy: 20, glow: 40 } },
  { key: "diva", name: "Diva", params: { smooth: 80, brighten: 45, whiten: 55, rosy: 40, glow: 30 } },
];

export const FILTER_PRESETS = [
  { key: "none", name: "None", swatch: "linear-gradient(135deg,#8b8b96,#3c3c46)", grade: {} },
  { key: "champagne", name: "Champagne", swatch: "linear-gradient(135deg,#f7e2b8,#d9a86a)", grade: { temperature: 0.18, brightness: 1.07, saturation: 1.05, contrast: 0.97, sepia: 0.08 } },
  { key: "cream", name: "Cream", swatch: "linear-gradient(135deg,#fdf3e3,#e8cba8)", grade: { brightness: 1.09, contrast: 0.9, saturation: 0.95, temperature: 0.06, tint: 0.05 } },
  { key: "rosequartz", name: "Rose Quartz", swatch: "linear-gradient(135deg,#fad2dd,#e393ad)", grade: { tint: 0.18, brightness: 1.06, saturation: 1.08, contrast: 0.96 } },
  { key: "velvet", name: "Velvet", swatch: "linear-gradient(135deg,#a04f6c,#4d1f35)", grade: { contrast: 1.14, saturation: 1.12, temperature: 0.1, brightness: 0.97 } },
  { key: "royalgold", name: "Royal Gold", swatch: "linear-gradient(135deg,#f2ca6b,#a8741f)", grade: { temperature: 0.32, sepia: 0.18, saturation: 1.15, contrast: 1.06, brightness: 1.02 } },
  { key: "moonlight", name: "Moonlight", swatch: "linear-gradient(135deg,#d9e6f5,#7e93b8)", grade: { temperature: -0.25, brightness: 1.05, contrast: 1.06, saturation: 0.88, tint: -0.05 } },
  { key: "peachy", name: "Peachy", swatch: "linear-gradient(135deg,#ffb9a3,#ff7e67)", grade: { temperature: 0.25, saturation: 1.15, brightness: 1.05 } },
  { key: "barbie", name: "Barbie", swatch: "linear-gradient(135deg,#ff9ad5,#ff4fa5)", grade: { tint: 0.3, saturation: 1.22, brightness: 1.06 } },
  { key: "seoul", name: "Seoul", swatch: "linear-gradient(135deg,#ffe3ec,#c3d6ff)", grade: { brightness: 1.1, contrast: 0.92, saturation: 1.06, temperature: -0.08, tint: 0.1 } },
  { key: "bollywood", name: "Bollywood", swatch: "linear-gradient(135deg,#ffcf5c,#ff5c39)", grade: { temperature: 0.3, saturation: 1.35, contrast: 1.08 } },
  { key: "goldenhour", name: "Golden Hour", swatch: "linear-gradient(135deg,#ffd98a,#e88b2d)", grade: { temperature: 0.45, saturation: 1.2, brightness: 1.04, sepia: 0.15 } },
  { key: "ice", name: "Ice", swatch: "linear-gradient(135deg,#cfefff,#6fb5e8)", grade: { temperature: -0.4, saturation: 0.9, brightness: 1.06, contrast: 1.05 } },
  { key: "tokyo", name: "Tokyo", swatch: "linear-gradient(135deg,#ff6fb5,#5c6cff)", grade: { contrast: 1.12, saturation: 1.3, tint: 0.15, temperature: -0.1 } },
  { key: "paris", name: "Paris", swatch: "linear-gradient(135deg,#f3e2cf,#c9a687)", grade: { sepia: 0.12, saturation: 1.1, brightness: 1.05, contrast: 0.96 } },
  { key: "sunset", name: "Sunset", swatch: "linear-gradient(135deg,#ff9d6f,#c44e9b)", grade: { temperature: 0.35, tint: 0.12, saturation: 1.3, sepia: 0.1 } },
  { key: "vivid", name: "Vivid", swatch: "linear-gradient(135deg,#3ee577,#00b2ff)", grade: { saturation: 1.5, contrast: 1.1 } },
  { key: "retro", name: "Retro", swatch: "linear-gradient(135deg,#d9b98a,#8a6d4d)", grade: { sepia: 0.45, contrast: 1.05, brightness: 0.98 } },
  { key: "drama", name: "Drama", swatch: "linear-gradient(135deg,#8a8a9c,#2e2e3c)", grade: { contrast: 1.25, saturation: 0.9, brightness: 0.96 } },
  { key: "noir", name: "Noir", swatch: "linear-gradient(135deg,#6a6a6a,#111)", grade: { gray: 1, contrast: 1.3, brightness: 0.95 } },
  { key: "bw", name: "B&W", swatch: "linear-gradient(135deg,#e8e8e8,#4a4a4a)", grade: { gray: 1, contrast: 1.15 } },
];

const GRADE_DEFAULTS = { brightness: 1, contrast: 1, saturation: 1, temperature: 0, tint: 0, sepia: 0, gray: 0 };

export const getGrade = (key) => ({ ...GRADE_DEFAULTS, ...(FILTER_PRESETS.find((f) => f.key === key)?.grade || {}) });

// CSS approximation (fallbacks only)
export function cssApprox(params, presetKey) {
  const g = getGrade(presetKey);
  const parts = [];
  if (params.smooth > 0) parts.push(`blur(${(params.smooth * 0.014).toFixed(2)}px)`);
  const b = g.brightness * (1 + params.brighten * 0.002 + params.whiten * 0.001);
  if (b !== 1) parts.push(`brightness(${b.toFixed(3)})`);
  const s = g.saturation * (1 + params.rosy * 0.0015) * (1 - g.gray);
  if (s !== 1) parts.push(`saturate(${Math.max(0, s).toFixed(3)})`);
  if (g.contrast !== 1) parts.push(`contrast(${g.contrast})`);
  if (g.sepia > 0) parts.push(`sepia(${g.sepia})`);
  if (g.gray > 0) parts.push(`grayscale(${g.gray})`);
  if (g.temperature !== 0) parts.push(`hue-rotate(${(-g.temperature * 12).toFixed(1)}deg)`);
  return parts.join(" ") || "none";
}

// ---------- Face + Pose tracking (lazy MediaPipe) ----------
let landmarkerPromise = null;
let posePromise = null;

function getLandmarker() {
  if (!landmarkerPromise) {
    landmarkerPromise = (async () => {
      const { FilesetResolver, FaceLandmarker } = await import("@mediapipe/tasks-vision");
      const fileset = await FilesetResolver.forVisionTasks("/mediapipe/wasm");
      const opts = (delegate) => ({
        baseOptions: { modelAssetPath: "/models/face_landmarker.task", delegate },
        runningMode: "VIDEO",
        numFaces: 1,
      });
      try {
        return await FaceLandmarker.createFromOptions(fileset, opts("GPU"));
      } catch (e) {
        return await FaceLandmarker.createFromOptions(fileset, opts("CPU"));
      }
    })().catch((e) => {
      landmarkerPromise = null;
      throw e;
    });
  }
  return landmarkerPromise;
}

function getPoseLandmarker() {
  if (!posePromise) {
    posePromise = (async () => {
      const { FilesetResolver, PoseLandmarker } = await import("@mediapipe/tasks-vision");
      const fileset = await FilesetResolver.forVisionTasks("/mediapipe/wasm");
      const opts = (delegate) => ({
        baseOptions: { modelAssetPath: "/models/pose_landmarker_lite.task", delegate },
        runningMode: "VIDEO",
        numPoses: 1,
      });
      try {
        return await PoseLandmarker.createFromOptions(fileset, opts("GPU"));
      } catch (e) {
        return await PoseLandmarker.createFromOptions(fileset, opts("CPU"));
      }
    })().catch((e) => {
      posePromise = null;
      throw e;
    });
  }
  return posePromise;
}

const dist = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
const mid = (a, b) => ({ x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 });

function faceGeometry(lm) {
  const faceW = dist(lm[234], lm[454]);
  const faceH = dist(lm[10], lm[152]);
  const roll = Math.atan2(lm[263].y - lm[33].y, lm[263].x - lm[33].x);
  const noseC = mid(lm[6], lm[4]);
  const mouthC = mid(lm[13], lm[14]);
  const faceC = mid(lm[10], lm[152]);
  const eyeRc = mid(lm[33], lm[133]);
  const eyeLc = mid(lm[263], lm[362]);
  const eyeRw = Math.max(dist(lm[33], lm[133]), 0.01);
  const eyeLw = Math.max(dist(lm[263], lm[362]), 0.01);
  return {
    faceW, faceH, roll, pts: lm,
    ellipse: [faceC.x, faceC.y, faceW * 0.68, faceH * 0.72],
    forehead: lm[10],
    noseTip: lm[4],
    chinPt: lm[152],
    eyeMid: mid(eyeRc, eyeLc),
    eyeR: eyeRc,
    eyeL: eyeLc,
    eyeREll: [eyeRc.x, eyeRc.y, eyeRw * 1.15, eyeRw * 0.95],
    eyeLEll: [eyeLc.x, eyeLc.y, eyeLw * 1.15, eyeLw * 0.95],
    chinEll: [lm[152].x, lm[152].y, faceW * 0.3, faceH * 0.2],
    eyeSpan: dist(lm[33], lm[263]),
    nose: [noseC.x, noseC.y, faceW * 0.16, faceH * 0.2],
    mouth: [mouthC.x, mouthC.y, Math.max(dist(lm[61], lm[291]) * 0.55, 0.01), Math.max(dist(lm[13], lm[14]) * 1.1, 0.012)],
  };
}

function bodyGeometry(pl) {
  const sh = mid(pl[11], pl[12]);
  const hip = mid(pl[23], pl[24]);
  const halfW = Math.max(dist(pl[11], pl[12]) * 0.8, 0.06);
  return { cx: (sh.x + hip.x) / 2, shoulderY: sh.y, hipY: hip.y, halfW };
}

const LIP_OUTER = [61, 146, 91, 181, 84, 17, 314, 405, 321, 375, 291, 409, 270, 269, 267, 0, 37, 39, 40, 185];
const LIP_INNER = [78, 95, 88, 178, 87, 14, 317, 402, 318, 324, 308, 415, 310, 311, 312, 13, 82, 81, 80, 191];
const LID_R = [33, 246, 161, 160, 159, 158, 157, 173, 133];
const LID_L = [263, 466, 388, 387, 386, 385, 384, 398, 362];

function tracePath(ctx, pts, ids, W, H) {
  ctx.moveTo(pts[ids[0]].x * W, pts[ids[0]].y * H);
  for (let i = 1; i < ids.length; i++) ctx.lineTo(pts[ids[i]].x * W, pts[ids[i]].y * H);
  ctx.closePath();
}

function drawMakeup(ctx, look, geo, W, H) {
  const pts = geo.pts;
  if (!pts) return;
  const fw = geo.faceW * W;
  if (look.lip && look.lipA > 0) {
    ctx.save();
    ctx.globalCompositeOperation = "multiply";
    ctx.globalAlpha = look.lipA;
    ctx.fillStyle = `rgb(${look.lip[0]},${look.lip[1]},${look.lip[2]})`;
    ctx.beginPath();
    tracePath(ctx, pts, LIP_OUTER, W, H);
    tracePath(ctx, pts, LIP_INNER, W, H);
    ctx.fill("evenodd");
    ctx.restore();
  }
  if (look.blush && look.blushA > 0) {
    ctx.save();
    ctx.globalCompositeOperation = "multiply";
    for (const i of [50, 280]) {
      const cx = pts[i].x * W, cy = pts[i].y * H, r = fw * 0.17;
      const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, r);
      g.addColorStop(0, `rgba(${look.blush[0]},${look.blush[1]},${look.blush[2]},${look.blushA})`);
      g.addColorStop(1, "rgba(255,255,255,0)");
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(cx, cy, r, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.restore();
  }
  if (look.smoke) {
    ctx.save();
    ctx.globalCompositeOperation = "multiply";
    for (const ell of [geo.eyeREll, geo.eyeLEll]) {
      const cx = ell[0] * W, cy = ell[1] * H - ell[3] * H * 0.8, r = ell[2] * W * 1.6;
      const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, r);
      g.addColorStop(0, `rgba(52,30,58,${look.smoke * 0.5})`);
      g.addColorStop(1, "rgba(255,255,255,0)");
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(cx, cy, r, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.restore();
  }
  if (look.liner > 0) {
    ctx.save();
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = `rgba(18,10,16,${0.5 + look.liner * 0.4})`;
    const lw = Math.max(1.2, fw * 0.014 * (0.7 + look.liner * 0.5));
    ctx.lineWidth = lw;
    for (const [ids, outIdx, inIdx] of [[LID_R, 33, 133], [LID_L, 263, 362]]) {
      ctx.beginPath();
      ctx.moveTo(pts[ids[0]].x * W, pts[ids[0]].y * H - lw * 0.35);
      for (let i = 1; i < ids.length; i++) ctx.lineTo(pts[ids[i]].x * W, pts[ids[i]].y * H - lw * 0.35);
      ctx.stroke();
      const ox = pts[outIdx].x * W, oy = pts[outIdx].y * H;
      const dx = ox - pts[inIdx].x * W, dy = oy - pts[inIdx].y * H;
      const len = Math.hypot(dx, dy) || 1;
      const wing = fw * 0.05 * (0.6 + look.liner * 0.6);
      ctx.beginPath();
      ctx.moveTo(ox, oy);
      ctx.lineTo(ox + (dx / len) * wing, oy + (dy / len) * wing - wing * 0.55);
      ctx.stroke();
    }
    ctx.restore();
  }
  if (look.bindi) {
    const bx = pts[9].x * W, by = pts[9].y * H - fw * 0.03;
    const r = fw * 0.032;
    ctx.save();
    const g = ctx.createRadialGradient(bx, by, 0, bx, by, r);
    g.addColorStop(0, "#E0263A");
    g.addColorStop(0.8, "#B01224");
    g.addColorStop(1, "rgba(150,10,26,0)");
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.arc(bx, by, r, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  }
}

const IMG_CACHE = {};
function getImg(src) {
  if (!IMG_CACHE[src]) {
    const img = new Image();
    img.src = src;
    IMG_CACHE[src] = img;
  }
  return IMG_CACHE[src];
}

function drawRotated(ctx, img, cx, cy, w, roll) {
  if (!img.complete || !img.naturalWidth) return;
  const h = (img.naturalHeight / img.naturalWidth) * w;
  ctx.save();
  ctx.translate(cx, cy);
  ctx.rotate(roll);
  ctx.drawImage(img, -w / 2, -h / 2, w, h);
  ctx.restore();
}

function drawSticker(ctx, key, geo, W, H) {
  const fw = geo.faceW * W;
  const roll = geo.roll;
  if (key === "crown") {
    const img = getImg("/assets/crown-maharaja.png");
    const w = fw * 1.15;
    const h = (img.naturalHeight / Math.max(img.naturalWidth, 1)) * w;
    drawRotated(ctx, img, geo.forehead.x * W, geo.forehead.y * H - h * 0.62, w, roll);
  } else if (key === "dog") {
    const ears = getImg("/assets/ar-dog-ears.png");
    const eh = (ears.naturalHeight / Math.max(ears.naturalWidth, 1)) * fw * 1.5;
    drawRotated(ctx, ears, geo.forehead.x * W, geo.forehead.y * H - eh * 0.3, fw * 1.5, roll);
    drawRotated(ctx, getImg("/assets/ar-dog-nose.png"), geo.noseTip.x * W, geo.noseTip.y * H + fw * 0.06, fw * 0.55, roll);
  } else if (key === "cat") {
    const ears = getImg("/assets/ar-cat-ears.png");
    const eh = (ears.naturalHeight / Math.max(ears.naturalWidth, 1)) * fw * 1.4;
    drawRotated(ctx, ears, geo.forehead.x * W, geo.forehead.y * H - eh * 0.45, fw * 1.4, roll);
  } else if (key === "sunglasses") {
    drawRotated(ctx, getImg("/assets/ar-sunglasses.png"), geo.eyeMid.x * W, geo.eyeMid.y * H, geo.eyeSpan * W * 1.75, roll);
  } else if (key === "hearts") {
    const img = getImg("/assets/ar-heart.png");
    drawRotated(ctx, img, geo.eyeR.x * W, geo.eyeR.y * H, fw * 0.34, roll);
    drawRotated(ctx, img, geo.eyeL.x * W, geo.eyeL.y * H, fw * 0.34, roll);
  }
}

// ---------- Shaders ----------
const VERT = `
attribute vec2 a_pos;
varying vec2 v_uv;
void main() {
  v_uv = a_pos * 0.5 + 0.5;
  gl_Position = vec4(a_pos, 0.0, 1.0);
}`;

const FRAG = `
precision mediump float;
varying vec2 v_uv;
uniform sampler2D u_tex;
uniform vec2 u_px;
uniform float u_smooth, u_brighten, u_whiten, u_rosy, u_glow;
uniform float u_slim, u_teeth, u_vface, u_bigeyes, u_chinp;
uniform vec4 u_nose, u_mouth, u_eyeR, u_eyeL, u_chinE;
uniform vec4 u_faceE;      // face ellipse: cx, cy, rx, ry (uv space, y flipped)
uniform float u_faceRoll;  // head roll
uniform float u_faceMode;  // 1 = face tracking active (mask beauty to face), 0 = legacy full-frame
uniform vec4 u_body;       // cx, shoulderY, hipY, halfW (uv space, y flipped)
uniform float u_bodySlim, u_longLegs, u_bodyMode;
uniform float u_gBrightness, u_gContrast, u_gSaturation, u_gTemperature, u_gTint, u_gSepia, u_gGray;

// feathered ellipse mask around the detected face — beauty applies only here
float faceMask(vec2 uv) {
  if (u_faceMode < 0.5) return 1.0;
  if (u_faceE.z < 0.001) return 0.0;
  vec2 d = uv - u_faceE.xy;
  float cs = cos(u_faceRoll), sn = sin(u_faceRoll);
  vec2 r = vec2(cs * d.x + sn * d.y, -sn * d.x + cs * d.y) / u_faceE.zw;
  return 1.0 - smoothstep(0.72, 1.08, length(r));
}

vec3 blur13(vec2 uv, float r) {
  vec2 px = u_px * r;
  vec3 acc = texture2D(u_tex, uv).rgb * 0.16;
  acc += texture2D(u_tex, uv + vec2( 1.0, 0.0) * px).rgb * 0.1;
  acc += texture2D(u_tex, uv + vec2(-1.0, 0.0) * px).rgb * 0.1;
  acc += texture2D(u_tex, uv + vec2( 0.0, 1.0) * px).rgb * 0.1;
  acc += texture2D(u_tex, uv + vec2( 0.0,-1.0) * px).rgb * 0.1;
  vec2 px2 = px * 2.2;
  acc += texture2D(u_tex, uv + vec2( 0.7, 0.7) * px2).rgb * 0.055;
  acc += texture2D(u_tex, uv + vec2(-0.7, 0.7) * px2).rgb * 0.055;
  acc += texture2D(u_tex, uv + vec2( 0.7,-0.7) * px2).rgb * 0.055;
  acc += texture2D(u_tex, uv + vec2(-0.7,-0.7) * px2).rgb * 0.055;
  acc += texture2D(u_tex, uv + vec2( 1.0, 0.0) * px2).rgb * 0.055;
  acc += texture2D(u_tex, uv + vec2(-1.0, 0.0) * px2).rgb * 0.055;
  acc += texture2D(u_tex, uv + vec2( 0.0, 1.0) * px2).rgb * 0.055;
  acc += texture2D(u_tex, uv + vec2( 0.0,-1.0) * px2).rgb * 0.055;
  return acc;
}

void main() {
  vec2 uv = v_uv;

  // ===== BODY RESTYLE (pose-tracked, y flipped: bottom of frame is uv.y = 0) =====
  if (u_bodyMode > 0.5 && u_body.w > 0.001) {
    // long legs: stretch content below the hip line downward
    if (u_longLegs > 0.01 && uv.y < u_body.z) {
      uv.y = u_body.z - (u_body.z - uv.y) * (1.0 - u_longLegs * 0.22);
    }
    // body slim: pinch toward the body axis from the shoulders down
    if (u_bodySlim > 0.01) {
      float vwin = 1.0 - smoothstep(u_body.y - 0.03, u_body.y + 0.1, uv.y);
      float dx = (uv.x - u_body.x) / max(u_body.w * 2.2, 0.001);
      float fall = exp(-dx * dx) * vwin;
      uv.x = u_body.x + (uv.x - u_body.x) * (1.0 + u_bodySlim * 0.14 * fall);
    }
  }

  // ===== FACE RESHAPE (face-tracked) =====
  // V-Face: slim the lower face toward the center axis
  if (u_vface > 0.01 && u_faceE.z > 0.001) {
    vec2 d = uv - u_faceE.xy;
    vec2 r = d / u_faceE.zw;
    float lower = smoothstep(0.05, 0.85, -r.y);
    float fall = exp(-dot(r, r) * 0.8) * lower;
    uv.x = u_faceE.x + d.x * (1.0 + u_vface * 0.28 * fall);
  }
  // Chin tip: taper toward a classy pointed chin
  if (u_chinp > 0.01 && u_chinE.z > 0.001) {
    vec2 dc = (uv - u_chinE.xy) / u_chinE.zw;
    float fall = exp(-dot(dc, dc) * 1.2);
    uv.x = u_chinE.x + (uv.x - u_chinE.x) * (1.0 + u_chinp * 0.3 * fall);
  }
  // Big eyes: subtle magnify around each eye
  if (u_bigeyes > 0.01 && u_eyeR.z > 0.001) {
    vec2 dr = (uv - u_eyeR.xy) / u_eyeR.zw;
    float lr = dot(dr, dr);
    if (lr < 1.0) {
      float k = u_bigeyes * 0.35 * pow(1.0 - lr, 1.4);
      uv = u_eyeR.xy + (uv - u_eyeR.xy) * (1.0 - k);
    }
    vec2 dl = (uv - u_eyeL.xy) / u_eyeL.zw;
    float ll = dot(dl, dl);
    if (ll < 1.0) {
      float k = u_bigeyes * 0.35 * pow(1.0 - ll, 1.4);
      uv = u_eyeL.xy + (uv - u_eyeL.xy) * (1.0 - k);
    }
  }
  // nose slim warp: sample wider region around nose axis
  if (u_slim > 0.01 && u_nose.z > 0.001) {
    vec2 d = (uv - u_nose.xy) / u_nose.zw;
    float fall = exp(-dot(d, d) * 1.4);
    uv.x = u_nose.x + (uv.x - u_nose.x) * (1.0 + u_slim * 0.45 * fall);
  }

  vec3 c = texture2D(u_tex, uv).rgb;
  float Y = dot(c, vec3(0.299, 0.587, 0.114));
  float fm = faceMask(uv);

  // YCbCr skin mask (avoids smoothing eyes/hair/lips inside the face)
  float Cb = (c.b - Y) * 0.565 + 0.5;
  float Cr = (c.r - Y) * 0.713 + 0.5;
  float skin = smoothstep(0.28, 0.33, Cb) * (1.0 - smoothstep(0.48, 0.53, Cb))
             * smoothstep(0.50, 0.55, Cr) * (1.0 - smoothstep(0.66, 0.71, Cr));

  // --- classy skin smoothing: face-only, edge-preserving, keeps real texture ---
  if (u_smooth > 0.01 && fm > 0.003) {
    vec3 blurred = blur13(uv, 1.0 + u_smooth * 3.5);
    float detail = Y - dot(blurred, vec3(0.299, 0.587, 0.114));
    float keepEdges = 1.0 - smoothstep(0.05, 0.16, abs(detail));
    float m = min(1.0, u_smooth * 1.25) * skin * fm * keepEdges;
    c = mix(c, blurred, m);
    c += vec3(detail) * 0.32 * m;  // add micro-texture back — no plastic look
    Y = dot(c, vec3(0.299, 0.587, 0.114));
  }

  // --- soft glow: gentle bloom on facial highlights ---
  if (u_glow > 0.01 && fm > 0.003) {
    vec3 soft = blur13(uv, 3.0);
    vec3 hl = max(soft - 0.55, 0.0);
    c += hl * u_glow * 0.65 * fm;
  }

  // --- precise teeth whitening (face-tracked mouth region) ---
  if (u_teeth > 0.01 && u_mouth.z > 0.001) {
    vec2 dm = (uv - u_mouth.xy) / u_mouth.zw;
    float inside = 1.0 - smoothstep(0.6, 1.0, dot(dm, dm));
    if (inside > 0.0) {
      float lum2 = dot(c, vec3(0.299, 0.587, 0.114));
      float toothMask = smoothstep(0.25, 0.55, lum2);
      vec3 white = clamp(vec3(lum2 * 1.25 + 0.15), 0.0, 1.0);
      c = mix(c, white, u_teeth * 0.8 * inside * toothMask);
    }
  }

  // --- skin whitening: face-only lift toward porcelain (plus highlight polish) ---
  if (u_whiten > 0.01 && fm > 0.003) {
    float mx = max(c.r, max(c.g, c.b));
    float mn = min(c.r, min(c.g, c.b));
    float sat = (mx - mn) / max(mx, 0.001);
    float hl = smoothstep(0.45, 0.9, Y) * (1.0 - smoothstep(0.15, 0.45, sat));
    float wm = max(hl, skin * u_faceMode * 0.8);
    c = mix(c, vec3(1.0), u_whiten * 0.45 * wm * fm);
  }

  // --- brighten: soft gamma lift on the face ---
  if (u_brighten > 0.01 && fm > 0.003) {
    vec3 lifted = pow(max(c, 0.0), vec3(1.0 / (1.0 + u_brighten * 0.55)));
    c = mix(c, lifted, fm);
  }

  // --- rosy glow on the cheeks/skin ---
  if (u_rosy > 0.01 && fm > 0.003) {
    c = mix(c, c * vec3(1.07, 0.965, 1.02) + vec3(0.02, 0.0, 0.013), u_rosy * fm * (skin * 0.7 + 0.3));
  }

  // --- color grade (filter preset) ---
  c.r += u_gTemperature * 0.08;
  c.b -= u_gTemperature * 0.08;
  c.r += u_gTint * 0.04;
  c.b += u_gTint * 0.04;
  c.g -= u_gTint * 0.05;
  float luma = dot(c, vec3(0.299, 0.587, 0.114));
  c = mix(vec3(luma), c, u_gSaturation);
  c = (c - 0.5) * u_gContrast + 0.5;
  c *= u_gBrightness;
  if (u_gSepia > 0.01) {
    vec3 sep = vec3(dot(c, vec3(0.393, 0.769, 0.189)), dot(c, vec3(0.349, 0.686, 0.168)), dot(c, vec3(0.272, 0.534, 0.131)));
    c = mix(c, sep, u_gSepia);
  }
  if (u_gGray > 0.01) {
    c = mix(c, vec3(dot(c, vec3(0.299, 0.587, 0.114))), u_gGray);
  }
  gl_FragColor = vec4(clamp(c, 0.0, 1.0), 1.0);
}`;

function compile(gl, type, src) {
  const sh = gl.createShader(type);
  gl.shaderSource(sh, src);
  gl.compileShader(sh);
  if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(sh));
  return sh;
}

function fallback2D(videoEl, getState) {
  let lastResume2 = 0;
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  let stopped = false;
  const loop = () => {
    if (stopped) return;
    if (videoEl.paused && videoEl.readyState >= 2 && performance.now() - lastResume2 > 1500) {
      lastResume2 = performance.now();
      videoEl.play().catch(() => {});
    }
    if (videoEl.videoWidth && (canvas.width !== videoEl.videoWidth || canvas.height !== videoEl.videoHeight)) {
      canvas.width = videoEl.videoWidth;
      canvas.height = videoEl.videoHeight;
    }
    const st = getState();
    if ("filter" in ctx) ctx.filter = cssApprox(st.params, st.presetKey);
    try { ctx.drawImage(videoEl, 0, 0, canvas.width, canvas.height); } catch (e) { /* frame not ready */ }
    requestAnimationFrame(loop);
  };
  if (!canvas.width) { canvas.width = 640; canvas.height = 480; }
  loop();
  return { canvas, stop: () => { stopped = true; } };
}

const needsFace = (st) => {
  const p = st.params || {};
  return (p.smooth || 0) > 0 || (p.brighten || 0) > 0 || (p.whiten || 0) > 0 || (p.rosy || 0) > 0
    || (p.glow || 0) > 0 || (p.vFace || 0) > 0 || (p.bigEyes || 0) > 0 || (p.chin || 0) > 0
    || (p.slimNose || 0) > 0 || (p.teethWhiten || 0) > 0 || (st.sticker && st.sticker !== "none")
    || (st.makeup && st.makeup !== "none");
};

const needsPose = (st) => {
  const p = st.params || {};
  return (p.bodySlim || 0) > 0 || (p.longLegs || 0) > 0;
};

export function createBeautyPipeline(videoEl, getState) {
  const glCanvas = document.createElement("canvas");
  glCanvas.width = 640;
  glCanvas.height = 480;
  let gl;
  try {
    gl = glCanvas.getContext("webgl", { premultipliedAlpha: false, preserveDrawingBuffer: false })
      || glCanvas.getContext("experimental-webgl");
  } catch (e) { gl = null; }
  if (!gl) return fallback2D(videoEl, getState);

  let prog;
  try {
    prog = gl.createProgram();
    gl.attachShader(prog, compile(gl, gl.VERTEX_SHADER, VERT));
    gl.attachShader(prog, compile(gl, gl.FRAGMENT_SHADER, FRAG));
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(prog));
  } catch (e) {
    console.error("beautyEngine shader error", e);
    return fallback2D(videoEl, getState);
  }
  gl.useProgram(prog);

  const buf = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
  const loc = gl.getAttribLocation(prog, "a_pos");
  gl.enableVertexAttribArray(loc);
  gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

  const tex = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, tex);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);

  const U = {};
  ["u_px", "u_smooth", "u_brighten", "u_whiten", "u_rosy", "u_glow",
    "u_slim", "u_teeth", "u_vface", "u_bigeyes", "u_chinp",
    "u_nose", "u_mouth", "u_eyeR", "u_eyeL", "u_chinE",
    "u_faceE", "u_faceRoll", "u_faceMode",
    "u_body", "u_bodySlim", "u_longLegs", "u_bodyMode",
    "u_gBrightness", "u_gContrast", "u_gSaturation", "u_gTemperature", "u_gTint", "u_gSepia", "u_gGray"]
    .forEach((n) => { U[n] = gl.getUniformLocation(prog, n); });

  // Output compositor canvas (GL frame + stickers)
  const outCanvas = document.createElement("canvas");
  outCanvas.width = 640;
  outCanvas.height = 480;
  const octx = outCanvas.getContext("2d");

  let stopped = false;
  let landmarker = null;
  let landmarkerLoading = false;
  let poser = null;
  let poserLoading = false;
  let geo = null;
  let body = null;
  let frame = 0;
  let lastResume = 0;

  const loop = () => {
    if (stopped) return;
    const vw = videoEl.videoWidth, vh = videoEl.videoHeight;
    // keep-alive: some browsers leave camera videos paused despite autoplay
    if (videoEl.paused && videoEl.readyState >= 2 && performance.now() - lastResume > 1500) {
      lastResume = performance.now();
      videoEl.play().catch(() => {});
    }
    if (vw && (glCanvas.width !== vw || glCanvas.height !== vh)) {
      glCanvas.width = vw;
      glCanvas.height = vh;
      outCanvas.width = vw;
      outCanvas.height = vh;
    }
    const st = getState();
    const wantFace = needsFace(st);
    const wantPose = needsPose(st);

    if (wantFace && !landmarker && !landmarkerLoading) {
      landmarkerLoading = true;
      getLandmarker().then((lm) => { landmarker = lm; }).catch((e) => console.error("Face tracking unavailable", e)).finally(() => { landmarkerLoading = false; });
    }
    if (wantPose && !poser && !poserLoading) {
      poserLoading = true;
      getPoseLandmarker().then((p) => { poser = p; }).catch((e) => console.error("Body tracking unavailable", e)).finally(() => { poserLoading = false; });
    }

    if (vw && videoEl.readyState >= 2) {
      frame += 1;
      if (wantFace && landmarker && frame % 2 === 0) {
        try {
          const res = landmarker.detectForVideo(videoEl, performance.now());
          geo = res.faceLandmarks && res.faceLandmarks[0] ? faceGeometry(res.faceLandmarks[0]) : null;
        } catch (e) { geo = null; }
      }
      if (wantPose && poser && frame % 3 === 1) {
        try {
          const res = poser.detectForVideo(videoEl, performance.now() + 0.001);
          body = res.landmarks && res.landmarks[0] ? bodyGeometry(res.landmarks[0]) : null;
        } catch (e) { body = null; }
      }
      if (!wantFace) geo = null;
      if (!wantPose) body = null;
      if (typeof window !== "undefined") {
        window.__yaaraFace = !!geo;
        window.__yaaraBody = !!body;
      }

      gl.viewport(0, 0, glCanvas.width, glCanvas.height);
      try {
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, videoEl);
        const p = st.params || BEAUTY_DEFAULTS;
        const g = getGrade(st.presetKey || "none");
        gl.uniform2f(U.u_px, 1 / glCanvas.width, 1 / glCanvas.height);
        gl.uniform1f(U.u_smooth, (p.smooth || 0) / 100);
        gl.uniform1f(U.u_brighten, (p.brighten || 0) / 100);
        gl.uniform1f(U.u_whiten, (p.whiten || 0) / 100);
        gl.uniform1f(U.u_rosy, (p.rosy || 0) / 100);
        gl.uniform1f(U.u_glow, (p.glow || 0) / 100);
        // face-tracked uniforms (uv space: y flipped)
        gl.uniform1f(U.u_faceMode, landmarker ? 1 : 0);
        if (geo) {
          gl.uniform1f(U.u_slim, (p.slimNose || 0) / 100);
          gl.uniform1f(U.u_teeth, (p.teethWhiten || 0) / 100);
          gl.uniform1f(U.u_vface, (p.vFace || 0) / 100);
          gl.uniform1f(U.u_bigeyes, (p.bigEyes || 0) / 100);
          gl.uniform1f(U.u_chinp, (p.chin || 0) / 100);
          gl.uniform4f(U.u_nose, geo.nose[0], 1 - geo.nose[1], geo.nose[2], geo.nose[3]);
          gl.uniform4f(U.u_mouth, geo.mouth[0], 1 - geo.mouth[1], geo.mouth[2], geo.mouth[3]);
          gl.uniform4f(U.u_eyeR, geo.eyeREll[0], 1 - geo.eyeREll[1], geo.eyeREll[2], geo.eyeREll[3]);
          gl.uniform4f(U.u_eyeL, geo.eyeLEll[0], 1 - geo.eyeLEll[1], geo.eyeLEll[2], geo.eyeLEll[3]);
          gl.uniform4f(U.u_chinE, geo.chinEll[0], 1 - geo.chinEll[1], geo.chinEll[2], geo.chinEll[3]);
          gl.uniform4f(U.u_faceE, geo.ellipse[0], 1 - geo.ellipse[1], geo.ellipse[2], geo.ellipse[3]);
          gl.uniform1f(U.u_faceRoll, -geo.roll);
        } else {
          gl.uniform1f(U.u_slim, 0);
          gl.uniform1f(U.u_teeth, 0);
          gl.uniform1f(U.u_vface, 0);
          gl.uniform1f(U.u_bigeyes, 0);
          gl.uniform1f(U.u_chinp, 0);
          gl.uniform4f(U.u_nose, 0, 0, 0, 0);
          gl.uniform4f(U.u_mouth, 0, 0, 0, 0);
          gl.uniform4f(U.u_eyeR, 0, 0, 0, 0);
          gl.uniform4f(U.u_eyeL, 0, 0, 0, 0);
          gl.uniform4f(U.u_chinE, 0, 0, 0, 0);
          gl.uniform4f(U.u_faceE, 0, 0, 0, 0);
          gl.uniform1f(U.u_faceRoll, 0);
        }
        // body-tracked uniforms
        if (body) {
          gl.uniform1f(U.u_bodyMode, 1);
          gl.uniform1f(U.u_bodySlim, (p.bodySlim || 0) / 100);
          gl.uniform1f(U.u_longLegs, (p.longLegs || 0) / 100);
          gl.uniform4f(U.u_body, body.cx, 1 - body.shoulderY, 1 - body.hipY, body.halfW);
        } else {
          gl.uniform1f(U.u_bodyMode, 0);
          gl.uniform1f(U.u_bodySlim, 0);
          gl.uniform1f(U.u_longLegs, 0);
          gl.uniform4f(U.u_body, 0, 0, 0, 0);
        }
        gl.uniform1f(U.u_gBrightness, g.brightness);
        gl.uniform1f(U.u_gContrast, g.contrast);
        gl.uniform1f(U.u_gSaturation, g.saturation);
        gl.uniform1f(U.u_gTemperature, g.temperature);
        gl.uniform1f(U.u_gTint, g.tint);
        gl.uniform1f(U.u_gSepia, g.sepia);
        gl.uniform1f(U.u_gGray, g.gray);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);

        octx.drawImage(glCanvas, 0, 0, outCanvas.width, outCanvas.height);
        if (st.makeup && st.makeup !== "none" && geo) {
          const look = MAKEUP_LOOKS.find((l) => l.key === st.makeup);
          if (look && look.key !== "none") drawMakeup(octx, look, geo, outCanvas.width, outCanvas.height);
        }
        if (st.sticker && st.sticker !== "none" && geo) {
          drawSticker(octx, st.sticker, geo, outCanvas.width, outCanvas.height);
        }
      } catch (e) { /* frame not ready */ }
    }
    requestAnimationFrame(loop);
  };
  loop();
  return { canvas: outCanvas, stop: () => { stopped = true; } };
}
